/* 🤖 this file was generated by svg-to-ts*/
export const icoTrendingUp: {
  name: 'trending-up';
  data: string;
} = {
  name: 'trending-up',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.92 6.62a1 1 0 00-.54-.54A1 1 0 0021 6h-4.998a1 1 0 100 1.999h2.589l-5.588 5.587-3.29-3.298a1 1 0 00-1.419 0l-5.998 5.997a1 1 0 000 1.42 1 1 0 001.42 0l5.288-5.298 3.289 3.298a1 1 0 001.42 0L20 9.408v2.59a1 1 0 001.999 0V7a1 1 0 00-.08-.38z" fill="#909090"/></svg>`
};
